import {
    TimeSeriesItem,
    TimeSeriesUnits,
} from "~/modules/token_timeseries/types";

// // // //

export function buildHypotheticalPerformanceFromNav(
    navData: TimeSeriesItem | undefined,
): TimeSeriesItem | null {
    const baselinePoint = navData?.points.find((point) => point[1] > 0);
    if (!navData || !baselinePoint) {
        return null;
    }

    const baselineValue = baselinePoint[1];

    return {
        ...navData,
        measure: {
            ...navData.measure,
            slug: "hypothetical_10_000_performance",
            name: "Hypothetical $10,000 Performance",
            unit: TimeSeriesUnits.dollar,
        },
        points: navData.points
            .filter((point) => point[1] > 0)
            .map((point) => [point[0], (point[1] / baselineValue) * 10_000]),
    };
}
